// ** Styles
import { useState, useCallback, useEffect } from 'react';
import '@styles/react/apps/app-roads.scss';
import { useParams } from 'react-router-dom';
import Wizard from '../shared/Wizard';
import { GetRoadById } from '../../../../graphql/Mutation';
import { useMutation } from '@apollo/client';

const FIELDS = [
  'name',
  'description',
  'status',
  'membership',
  'cover',
  'episodes',
  'disable',
  'new',
  'challenge'
];

const EditRoad = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [getRoadById] = useMutation(GetRoadById);

  const formatData = (data) => {
    const formatedData = {};
    FIELDS.map((key) => {
      formatedData[key] = data[key];
    });
    setValues({
      ...formatedData,
      __typename: undefined
    });
  };

  const handleFetch = useCallback(async () => {
    try {
      const {
        data: { getRoadById: data }
      } = await getRoadById({ variables: { roadId: id } });

      formatData(data);
      setLoading(false);
    } catch (e) {}
  }, []);

  useEffect(() => {
    handleFetch();
  }, [handleFetch]);

  return !loading ? (
    <Wizard editMode={true} defaultValues={values} roadId={id} />
  ) : null;
};

export default EditRoad;
